import styled from "@emotion/styled"

const ButtonContainer = styled.button`
    background: none;
    border: none;
    padding: 0;
    margin: 0;

    font-family: Gilroy;
    font-weight: 500;
    font-size: 16rem;
    line-height: 24rem;
    letter-spacing: 0%;
    text-align: center;

    height: 40rem;

    background: linear-gradient(to right, #ff3568, #ff33cc);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;

    cursor: pointer;
`

type ButtonTextProps = ExtractStyledProps<typeof ButtonContainer>

function ButtonText(props: ButtonTextProps) {
    return <ButtonContainer {...props} />
}

export default ButtonText
